import { BaseModel } from './base-model';

export class Servicio extends BaseModel {
  categoriaServicioId?: number | null;
  nombre?: string | null;
  estado?: string | null;
  categoriaServicio?: CategoriaServicio;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.categoriaServicio) {
        this.categoriaServicio = new CategoriaServicio(object.categoriaServicio);
      }
    }
  }
}

export class CategoriaServicio extends BaseModel {
  nombre?: string | null;

  constructor(object?: any) {
    super(object);
  }
}
